import React, { useState } from "react";
import { Typography, AnchorMenu } from "components";
import { logOut, getUserType, isUserActive, isAdminUser } from "utils/helper";
import {
  MdNotifications,
  MdOutlineKeyboardArrowDown,
  MdPersonOutline,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { IoLogOutOutline } from "react-icons/io5";
import { pocketMoniUrl } from "routes/routePaths";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/routePaths";
import pmLogo from "assets/images/pocketmoni-logo.png";
import userAvatar from "assets/images/user-avatar.png";

import "./style.scss";

const DashboardNavbar = ({ handleSidebarOpen }) => {
  const navigate = useNavigate();

  const [dropDownOpen, setDropDownOpen] = useState(false);

  const openDropDown = () => setDropDownOpen(!dropDownOpen);

  const { user } = useSelector((state) => state.user);

  const anchorRender = () => (
    <div className="profile-dropdown px-3">
      {!isAdminUser(user) && (
        <>
          <div className="d-flex">
            <Typography style={{ color: "#BDBABC" }} variant="body3">
              PM Number{" "}
            </Typography>{" "}
            &nbsp;
            <Typography variant="body4" state="primary">
              - {user.mobile}
            </Typography>
          </div>

          <div className="d-flex my-3">
            <Typography style={{ color: "#BDBABC" }} variant="body3">
              Agent Code
            </Typography>{" "}
            &nbsp;
            <Typography variant="body4" state="primary">
              - {user.agent_code}
            </Typography>
          </div>
        </>
      )}

      <div
        className="d-flex mb-3 align-items-center cursor-pointer"
        onClick={() => navigate(ROUTES.userProfile)}
      >
        <MdPersonOutline color="#102E88" fontSize="22px" /> &nbsp;
        <Typography variant="body3" state="primary">
          View Profile
        </Typography>
      </div>

      <div
        className="d-flex my-3 align-items-center cursor-pointer"
        onClick={logOut}
      >
        <IoLogOutOutline fontSize="22px" className="font-danger" /> &nbsp;
        <Typography variant="body3" className="font-danger">
          Logout
        </Typography>
      </div>
    </div>
  );

  return (
    <div className="dashboard-navbar-container d-flex align-items-center justify-content-between">
      <a
        href={pocketMoniUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="d-none d-lg-block"
      >
        <img src={pmLogo} width="110px" alt="PocketMoni" />
      </a>

      <div className="d-block d-lg-none cursor-pointer">
        <HiOutlineMenuAlt1 fontSize="24px" onClick={handleSidebarOpen} />
      </div>

      <div className="d-flex align-items-center">
        <div className="mx-3 pt-3 notification-container d-none">
          <MdNotifications color="#102E88" fontSize="26px" />
          <div className=" d-flex align-items-center justify-content-center">
            6
          </div>
        </div>
        <div className="user-avatar mt-2">
          <img
            src={userAvatar}
            alt={user?.corporate_name || user?.firstname}
            height="45px"
          />
          <div className="online--admin"></div>
        </div>
        &nbsp;
        <div className="mx-2 d-none d-lg-block">
          <Typography variant="body4">
            {user?.corporate_name || user?.firstname}
          </Typography>
          <Typography variant="body3">{getUserType(user)}</Typography>
        </div>
        {isUserActive(user?.status) && (
          <div
            className="mx-2 dropdown-container d-flex justify-content-center align-items-center d-none d-lg-flex"
            tabIndex={0}
            onClick={openDropDown}
            onBlur={openDropDown}
          >
            <AnchorMenu
              anchorRender={anchorRender}
              iconRender={<MdOutlineKeyboardArrowDown fontSize="20px" />}
              customWidth={"15rem"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardNavbar;
